import React, { useContext, useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../teacherStore";
import { getStudentAnswersByQuestion } from "../../../../libs/ActiveLearning";
import TreeCard from "../../../../atoms/ActiveLearning/TreeCard";
import styles from "../ActiveLearningLessonAnswerData.module.scss";

interface ILesson7Pros {
  materialCode: string;
  lessonNo: number;
}

export const Lesson7: React.FC<ILesson7Pros> = ({ materialCode, lessonNo }) => {
  const { state } = useContext(Context);
  const activeLearningStudentAnswers = state.active_learning_student_answers;

  const answersL7I1Q2 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      1,
      2,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL5I2Q6 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      materialCode === "ECS001" ? 5 : 6,
      2,
      6,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers]);

  const answersL7I1Q1 = useMemo(() => {
    return getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      1,
      1,
    );
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL7I2Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      2,
      1,
    );

    if (answers.length > 0) {
      const [answer] = answers;
      const stepNo = answer.contents.stepNo;
      return answersL7I1Q1.find(answer => answer.contents.stepNo === stepNo)
        ?.contents.value;
    } else {
      return "回答データがありません。";
    }
  }, [materialCode, activeLearningStudentAnswers, answersL7I1Q1, lessonNo]);

  const answersL7I2Q2 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      2,
      2,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo}{" "}
        実現のステップを描いて第一歩を踏み出そう
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <p className={styles.heading}>
            アイデアの実現までにやることを考え、ステップを設定しよう。
          </p>
          <div className={styles.question}>
            <p className={clsx(styles.heading, styles.dot)}>
              やることを洗い出し、優先順位を考えながらステップを設定しよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL7I1Q2}</p>
          </div>
          <div className={styles.question}>
            <div className={styles.tree}>
              <TreeCard
                title={"実現したいと思う解決のアイデア"}
                text={answersL5I2Q6}
              />
              <ul className={styles.branchList}>
                {answersL7I1Q1.length > 0 ? (
                  answersL7I1Q1.reverse().map(answer => (
                    <li key={answer.id} className={styles.branch}>
                      <div className={styles.labelWrapper}>
                        <span className={styles.label}>
                          ステップ{answer.contents.stepNo}
                        </span>
                      </div>
                      <p className={styles.answer}>{answer.contents.value}</p>
                    </li>
                  ))
                ) : (
                  <li className={styles.branch}>
                    <div className={styles.labelWrapper}>
                      <span className={styles.label}>ステップ</span>
                    </div>
                    <p className={styles.answer}>回答データがありません。</p>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK02</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              次のLessonまでに、どのステップまでの行動をしてくるか決めよう。
            </p>
            <p className={styles.answer}>{answersL7I2Q1}</p>
          </div>
          <div className={styles.question}>
            <p className={clsx(styles.heading, styles.dot)}>
              その行動によってどんな結果が得られたらいいのかを考えてみよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL7I2Q2}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson7;
